import React, { useState, useEffect, useRef } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import { createPortal } from "react-dom";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FaTags, FaPlus, FaTrash, FaEdit, FaTimes, FaEllipsisV, FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Footer from "../../composant_reutilisable/footer";
import QuillEditor from "./quilleditors";

const ModalAvecEditeur = React.memo(({
    show,
    handleClose,
    title,
    formData,
    handleSubmit,
    submitText,
    isEdit = false,
    imageFiles,
    imageDefautIndex,
    handleImagesChange,
    handleSetImageDefaut,
    handleRemoveImage,
    existingImages = [],
    imagesASupprimer = [],
    isDefaultFromNew,
    nouvelleImageDefautId,
    handleDefinirImageDefaut,
    handleSupprimerImage
}) => {
    const [localFormData, setLocalFormData] = useState(formData);

    useEffect(() => {
        setLocalFormData(formData);
    }, [formData]);

    const handleChange = (e) => {
        setLocalFormData({ ...localFormData, [e.target.name]: e.target.value });
    };

    const handleDescriptionChange = (content) => {
        setLocalFormData({ ...localFormData, description: content });
    };

    const handleSubmitLocal = () => {
        handleSubmit(localFormData);
    };

    const displayedExisting = existingImages.filter(image => !imagesASupprimer.includes(image.id));
    const totalImages = displayedExisting.length + imageFiles.length;

    return (
        <Modal show={show} onHide={handleClose} size="lg" onEntered={() => document.querySelector('input[name="nom"]')?.focus()}>
            <Modal.Header className="pb-2">
                <Modal.Title className="h5">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-3" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Nom de la catégorie *</Form.Label>
                        <Form.Control
                            type="text"
                            name="nom"
                            value={localFormData.nom}
                            onChange={handleChange}
                            placeholder="Ex: Concert, Mariage..."
                            required
                            className="py-2"
                            autoFocus
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Description</Form.Label>
                        <QuillEditor
                            value={localFormData.description}
                            onChange={handleDescriptionChange}
                            placeholder="Description de la catégorie..."
                        />
                    </Form.Group>

                    {/* Section pour ajouter de nouvelles images */}
                    <Form.Group className="mb-1">
                        <Form.Label className="fw-semibold">
                            {isEdit ? 'Ajouter de nouvelles images' : 'Images de la catégorie *'}
                        </Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleImagesChange}
                            className="py-2"
                        />
                        <Form.Text className="text-muted">
                            Formats supportés: JPG, PNG, GIF. Taille max: 5MB par image.
                            Vous pouvez sélectionner plusieurs images à la fois.
                        </Form.Text>

                        {((isEdit && displayedExisting.length > 0) || imageFiles.length > 0) && (
                            <div className="mt-3">
                                <Form.Label className="fw-semibold">Aperçu des images - Sélectionnez l'image par défaut:</Form.Label>
                                <Row className="g-3 mt-2">
                                    {isEdit && displayedExisting.map((image, index) => {
                                        const isCurrentDefault = !isDefaultFromNew && (nouvelleImageDefautId === image.id || (nouvelleImageDefautId === null && image.est_defaut));
                                        return (
                                            <Col md={4} key={image.id} className="mb-3">
                                                <div
                                                    className={`image-preview position-relative ${isCurrentDefault ? 'border border-primary border-4' : 'border border-light'}`}
                                                    style={{
                                                        borderRadius: '12px',
                                                        padding: '15px',
                                                        backgroundColor: '#ffffff',
                                                        cursor: 'pointer',
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                                        transition: 'all 0.3s ease',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                    onClick={() => handleDefinirImageDefaut(image.id)}
                                                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                >
                                                    <div
                                                        style={{
                                                            position: 'relative',
                                                            width: '100%',
                                                            height: '120px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={image.url}
                                                            alt={`Image ${index + 1}`}
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '8px',
                                                            }}
                                                        />
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            className="position-absolute top-0 start-0 rounded-circle p-1"
                                                            style={{
                                                                width: '28px',
                                                                height: '28px',
                                                                opacity: 0.95,
                                                                zIndex: 10,
                                                                marginLeft: '220px',
                                                                marginBottom: '140px'
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleSupprimerImage(image.id);
                                                            }}
                                                            disabled={isCurrentDefault && totalImages === 1}
                                                        >
                                                            <FaTimes size={12} />
                                                        </Button>
                                                    </div>
                                                    <small
                                                        className="text-center mt-2"
                                                        style={{
                                                            fontSize: '0.75rem',
                                                            color: isCurrentDefault ? '#0d6efd' : '#6c757d',
                                                            fontWeight: isCurrentDefault ? '600' : '400',
                                                        }}
                                                    >
                                                        {isCurrentDefault ? 'Image par défaut' : 'Cliquer pour définir'}
                                                    </small>
                                                </div>
                                            </Col>
                                        );
                                    })}
                                    {imageFiles.map((file, index) => {
                                        const isCurrentDefault = isDefaultFromNew && imageDefautIndex === index;
                                        return (
                                            <Col md={4} key={`new-${index}`} className="mb-3">
                                                <div
                                                    className={`image-preview position-relative ${isCurrentDefault ? 'border border-primary border-4' : 'border border-light'}`}
                                                    style={{
                                                        borderRadius: '12px',
                                                        padding: '15px',
                                                        backgroundColor: '#ffffff',
                                                        cursor: 'pointer',
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                                        transition: 'all 0.3s ease',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                    onClick={() => handleSetImageDefaut(index)}
                                                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                >
                                                    <div
                                                        style={{
                                                            position: 'relative',
                                                            width: '100%',
                                                            height: '120px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={URL.createObjectURL(file)}
                                                            alt={`Aperçu ${index + 1}`}
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '8px',
                                                            }}
                                                        />
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            className="position-absolute top-0 start-0 rounded-circle p-1"
                                                            style={{
                                                                width: '28px',
                                                                height: '28px',
                                                                opacity: 0.95,
                                                                zIndex: 10,
                                                                marginLeft: '220px',
                                                                marginBottom: '140px'
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveImage(index);
                                                            }}
                                                            disabled={isCurrentDefault && totalImages === 1}
                                                        >
                                                            <FaTimes size={12} />
                                                        </Button>
                                                    </div>
                                                    <small
                                                        className="text-center mt-2"
                                                        style={{
                                                            fontSize: '0.75rem',
                                                            color: isCurrentDefault ? '#0d6efd' : '#6c757d',
                                                            fontWeight: isCurrentDefault ? '600' : '400',
                                                        }}
                                                    >
                                                        {isCurrentDefault ? 'Image par défaut' : 'Cliquer pour définir'}
                                                    </small>
                                                </div>
                                            </Col>
                                        );
                                    })}
                                </Row>
                                <div className="mt-1">
                                    <small className="text-info">
                                        {totalImages} image(s) sélectionnée(s). Cliquez sur une image pour la définir comme image par défaut.
                                    </small>
                                </div>
                            </div>
                        )}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="pt-2">
                <Button variant="secondary" onClick={handleClose} className="px-3">
                    Annuler
                </Button>
                <Button
                    variant="success"
                    onClick={handleSubmitLocal}
                    disabled={!isEdit && imageFiles.length === 0}
                    className="px-3"
                >
                    {submitText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
});

const CategoriesEvenement = () => {
    useAuth();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [menu, setMenu] = useState(null);
    const menuRef = useRef(null);
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [sortConfig, setSortConfig] = useState({ key: "date_creation", direction: "descending" });
    const [filtreStatut, setFiltreStatut] = useState("tous");
    const [categories, setCategories] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [categorieSelectionnee, setCategorieSelectionnee] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [imagesASupprimer, setImagesASupprimer] = useState([]);
    const [nouvelleImageDefautId, setNouvelleImageDefautId] = useState(null);
    const [isDefaultFromNew, setIsDefaultFromNew] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "Showtime | Gestion des Catégories";
        }
    }, [user_id]);

    // États pour gérer les modals
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [nouvelleCategorie, setNouvelleCategorie] = useState({
        nom: "",
        description: ""
    });
    const [imageFiles, setImageFiles] = useState([]);
    const [imageDefautIndex, setImageDefautIndex] = useState(0);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    // Récupération des catégories
    const fetchCategories = async () => {
        try {
            setIsLoading(true);
            const token = localStorage.getItem('access_token')
            const response = await fetch(`${process.env.REACT_APP_HOTE}/api/categories-evenement/`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.ok) {
                const data = await response.json();
                setCategories(data);
            } else {
                console.error("Erreur lors de la récupération des catégories");
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des catégories:", error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    // Filtrage et recherche
    const categoriesFiltrees = categories.filter(categorie => {
        const descriptionText = categorie.description ? categorie.description.replace(/<[^>]*>/g, '') : '';

        const matchesSearch =
            categorie?.nom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            descriptionText.toLowerCase().includes(searchTerm.toLowerCase()) ||
            new Date(categorie.date_creation).toLocaleDateString('fr-FR').toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = filtreStatut === "tous" ||
            (filtreStatut === "actif" && categorie.est_active) ||
            (filtreStatut === "inactif" && !categorie.est_active);

        return matchesSearch && matchesStatus;
    });

    // Tri
    const sortedCategories = [...categoriesFiltrees].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };

    // Pagination
    const totalItems = categoriesFiltrees.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentCategories = sortedCategories.slice(indexOfFirstItem, indexOfLastItem);

    // Gestion du menu contextuel
    const handleClick = (event, categorie) => {
        event.stopPropagation();

        if (menu?.categorie?.id === categorie.id) {
            setMenu(null);
            return;
        }

        const buttonRect = event.currentTarget.getBoundingClientRect();

        setMenu({
            categorie,
            x: buttonRect.left,
            y: buttonRect.bottom
        });
    };

    const closeMenu = () => setMenu(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isActionButton = event.target.closest(".action-button");
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !isActionButton
            ) {
                closeMenu();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [menu]);

    // Gestion des modals
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setNouvelleCategorie({ nom: "", description: "" });
        setImageFiles([]);
        setImageDefautIndex(0);
    };

    const handleOpenEditModal = (categorie) => {
        setCategorieSelectionnee(categorie);
        setNouvelleCategorie({
            nom: categorie.nom || "",
            description: categorie.description || ""
        });
        setImageFiles([]);
        setImageDefautIndex(0);
        setImagesASupprimer([]);
        setNouvelleImageDefautId(null);
        setIsDefaultFromNew(false);
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setNouvelleCategorie({ nom: "", description: "" });
        setImageFiles([]);
        setImageDefautIndex(0);
        setImagesASupprimer([]);
        setNouvelleImageDefautId(null);
    };

    const handleImagesChange = (e) => {
        const files = Array.from(e.target.files);
        setImageFiles(prevFiles => [...prevFiles, ...files]);
    };

    const handleRemoveImage = (index) => {
        setImageFiles(prevFiles => {
            const newFiles = prevFiles.filter((_, i) => i !== index);
            let newIndex = imageDefautIndex;
            if (imageDefautIndex === index && newFiles.length > 0) {
                newIndex = 0; // Réinitialiser à la première si on supprime la défaut
            } else if (imageDefautIndex > index) {
                newIndex--;
            }
            if (newFiles.length === 0 && isDefaultFromNew) {
                setIsDefaultFromNew(false);
                setNouvelleImageDefautId(null);
                setImageDefautIndex(-1);
            } else {
                setImageDefautIndex(newIndex);
            }
            return newFiles;
        });
    };

    const handleSetImageDefaut = (index) => {
        setImageDefautIndex(index);
        setIsDefaultFromNew(true);
        setNouvelleImageDefautId(null);
    };

    // Définir une image comme défaut
    const handleDefinirImageDefaut = (imageId) => {
        if (!categorieSelectionnee) return;

        // Stocker l'ID pour l'envoyer dans la modification
        setNouvelleImageDefautId(imageId);
        setIsDefaultFromNew(false);
        setImageDefautIndex(-1);
    };

    // Supprimer une image
    const handleSupprimerImage = (imageId) => {
        setImagesASupprimer(prevImages => {
            const newImagesASupprimer = [...prevImages, imageId];
            if (nouvelleImageDefautId === imageId && !isDefaultFromNew) {
                const remainingExisting = categorieSelectionnee?.images.filter(img => !newImagesASupprimer.includes(img.id));
                if (remainingExisting.length > 0) {
                    setNouvelleImageDefautId(remainingExisting[0].id);
                } else if (imageFiles.length > 0) {
                    setIsDefaultFromNew(true);
                    setImageDefautIndex(0);
                }
            }
            return newImagesASupprimer;
        });
    };

    // Ajouter une catégorie
    const handleAjouterCategorie = async (formData = nouvelleCategorie) => {
        if (!formData.nom.trim()) {
            showAlert("Le nom de la catégorie est obligatoire.", "danger");
            return;
        }

        if (imageFiles.length === 0) {
            showAlert("Au moins une image est requise.", "danger");
            return;
        }

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('nom', formData.nom);
            formDataToSend.append('description', formData.description);
            formDataToSend.append('image_defaut_index', imageDefautIndex);

            imageFiles.forEach((file, index) => {
                formDataToSend.append('images', file);
            });

            const token = localStorage.getItem('access_token')
            const response = await fetch(`${process.env.REACT_APP_HOTE}/api/categories-evenement/ajouter/${user_id}/`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formDataToSend,
            });

            if (response.ok) {
                await response.json();
                fetchCategories();
                handleCloseModal();
                showAlert("Catégorie ajoutée avec succès", "success");
            } else {
                const error = await response.json();
                showAlert(error.error || "Erreur lors de l'ajout de la catégorie.", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Une erreur est survenue. Veuillez réessayer.", "danger");
        }
    };

    const handleModifierCategorie = async (formData = nouvelleCategorie) => {
        if (!categorieSelectionnee) return;

        try {
            const formDataToSend = new FormData();
            formDataToSend.append("nom", formData.nom);
            formDataToSend.append("description", formData.description);

            // Override pour PUT
            formDataToSend.append("_method", "PUT");

            // Ajouter nouvelles images
            if (imageFiles.length > 0) {
                formDataToSend.append("image_defaut_index", imageDefautIndex);
                imageFiles.forEach((file) => formDataToSend.append("images", file));
            } else {
                formDataToSend.append("image_defaut_index", -1);
            }

            // Ajouter IDs à supprimer
            if (imagesASupprimer.length > 0) {
                imagesASupprimer.forEach((id) =>
                    formDataToSend.append("images_a_supprimer[]", id)
                );
            }

            // Nouvelle image par défaut
            if (nouvelleImageDefautId) {
                formDataToSend.append("nouvelle_image_defaut_id", nouvelleImageDefautId);
            }

            const token = localStorage.getItem('access_token')
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/api/categories-evenement/modifier/${categorieSelectionnee.id}/${user_id}/`,
                {
                    method: "POST", // POST obligatoire pour FormData
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    body: formDataToSend,
                }
            );

            const result = await response.json();
            console.log("Réponse backend:", result);

            if (response.ok && result.success) {
                fetchCategories();
                handleCloseEditModal();
                showAlert("Catégorie modifiée avec succès", "success");
            } else {
                showAlert(result.error || "Erreur lors de la modification.", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Une erreur est survenue. Veuillez réessayer.", "danger");
        }
    };



    // Supprimer une catégorie
    const handleShowDeleteModal = (categorie) => {
        setCategorieSelectionnee(categorie);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleDeleteCategorie = async () => {
        if (categorieSelectionnee) {
            try {
                const token = localStorage.getItem('access_token')
                const response = await fetch(`${process.env.REACT_APP_HOTE}/api/categories-evenement/supprimer/${categorieSelectionnee.id}/${user_id}/`, {
                    method: 'DELETE',
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${token}`
                    },
                });

                if (response.ok) {
                    fetchCategories();
                    setCategorieSelectionnee(null);
                    showAlert('Catégorie supprimée avec succès !');
                } else {
                    const error = await response.json();
                    showAlert(error.error || "Erreur lors de la suppression de la catégorie.", "danger");
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert("Une erreur est survenue. Veuillez réessayer.", "danger");
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    // Voir l'image en grand
    const handleViewImage = (imageUrl) => {
        setSelectedImage(imageUrl);
        setShowImageModal(true);
    };

    const handleCloseImageModal = () => {
        setShowImageModal(false);
        setSelectedImage(null);
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaTags size={25} className='mr-2' />Gestion des Catégories d'Événements
                                </div>
                            </h2>
                            <small>Administration des catégories d'événements pour l'application mobile.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={`/Dashboard`}>Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Catégories Événements
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des catégories</h5>
                            <div className="text-right">
                                <button className="btn btn-success mr-2" onClick={handleOpenModal}>
                                    <FaPlus /> Ajouter une catégorie
                                </button>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div
                                            className="d-flex justify-content-between align-items-center mb-3"
                                            style={{ gap: "10px" }}
                                        >
                                            <div
                                                className="d-flex align-items-center"
                                                style={{ gap: "10px" }}
                                            >
                                                <select
                                                    id="itemsPerPage"
                                                    value={itemsPerPage}
                                                    onChange={(e) => {
                                                        setItemsPerPage(Number(e.target.value));
                                                        setCurrentPage(1);
                                                    }}
                                                    className="form-select bg-default p-1"
                                                    style={{
                                                        width: "auto",
                                                        border: "1px black solid",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                                {/* <select
                                                    value={filtreStatut}
                                                    onChange={(e) => setFiltreStatut(e.target.value)}
                                                    className="form-select bg-default p-1"
                                                    style={{
                                                        width: "auto",
                                                        border: "1px black solid",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <option value="tous">Tous les statuts</option>
                                                    <option value="actif">Actives</option>
                                                    <option value="inactif">Inactives</option>
                                                </select> */}
                                            </div>

                                            <input
                                                type="text"
                                                placeholder="Rechercher..."
                                                className="form-control"
                                                style={{ maxWidth: "250px", width: "100%" }}
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>

                                        <div className="table-responsive">
                                            <table
                                                className="footable table table-stripped footable-loaded tablet breakpoint"
                                                data-page-size="8"
                                                data-filter="#filter"
                                                style={{ fontSize: "12px" }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th
                                                            className="text-secondary text-wrap d-none d-md-table-cell"
                                                            onClick={() => handleSort("nom")}
                                                            style={{ width: "15%", minWidth: "100px" }}
                                                        >
                                                            Nom
                                                            {sortConfig.key === "nom"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th
                                                            className="text-secondary text-wrap d-none d-md-table-cell"
                                                            style={{ width: "20%", minWidth: "150px" }}
                                                        >
                                                            Description
                                                        </th>
                                                        <th
                                                            className="text-secondary text-wrap text-center d-none d-md-table-cell align-middle"
                                                            style={{ width: "8%", minWidth: "80px" }}
                                                        >
                                                            Image
                                                        </th>
                                                        <th
                                                            className="text-secondary text-wrap text-center d-none d-md-table-cell align-middle"
                                                            onClick={() => handleSort("images")}
                                                            style={{ width: "8%", minWidth: "80px" }}
                                                        >
                                                            Nb Images
                                                            {sortConfig.key === "images"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th
                                                            className="text-secondary text-wrap text-center d-none d-md-table-cell align-middle"
                                                            onClick={() => handleSort("date_creation")}
                                                            style={{ width: "10%", minWidth: "100px" }}
                                                        >
                                                            Date création
                                                            {sortConfig.key === "date_creation"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th
                                                            className="text-secondary text-wrap text-center d-none d-md-table-cell align-middle"
                                                            onClick={() => handleSort("est_active")}
                                                            style={{ width: "8%", minWidth: "80px" }}
                                                        >
                                                            Statut
                                                            {sortConfig.key === "est_active"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th
                                                            className="text-secondary text-wrap text-center d-none d-md-table-cell align-middle"
                                                            style={{ width: "1%", minWidth: "60px" }}
                                                        >
                                                            Actions
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentCategories && currentCategories.length > 0 ? (
                                                        currentCategories.map((categorie) => {
                                                            const imageDefaut = categorie.images?.find(img => img.est_defaut) || categorie.images?.[0];
                                                            return (
                                                                <tr
                                                                    key={categorie.id}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <td
                                                                        className="d-none d-md-table-cell align-middle"
                                                                        style={{ padding: "0.5rem" }}
                                                                    >
                                                                        <span>{categorie.nom}</span>
                                                                    </td>
                                                                    <td
                                                                        className="d-none d-md-table-cell align-middle"
                                                                        style={{ padding: "0.5rem" }}
                                                                    >
                                                                        <div
                                                                            dangerouslySetInnerHTML={{ __html: categorie.description || "Aucune description" }}
                                                                            style={{
                                                                                maxWidth: '300px',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                            title={categorie.description ? categorie.description.replace(/<[^>]*>/g, '') : "Aucune description"}
                                                                        />
                                                                    </td>
                                                                    <td
                                                                        className="d-none d-md-table-cell text-center align-middle"
                                                                        style={{ padding: "0.5rem" }}
                                                                    >
                                                                        {imageDefaut ? (
                                                                            <img
                                                                                src={imageDefaut.url}
                                                                                alt={categorie.nom}
                                                                                style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px', cursor: 'pointer' }}
                                                                                onClick={() => handleViewImage(imageDefaut.url)}
                                                                            />
                                                                        ) : (
                                                                            <span className="text-muted">Aucune</span>
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        className="d-none d-md-table-cell text-center align-middle"
                                                                        style={{ padding: "0.5rem" }}
                                                                    >
                                                                        <span className="fw-semibold">{categorie.images?.length || 0}</span>
                                                                    </td>
                                                                    <td
                                                                        className="d-none d-md-table-cell text-center align-middle"
                                                                        style={{ padding: "0.5rem" }}
                                                                    >
                                                                        <span>{new Date(categorie.date_creation).toLocaleDateString('fr-FR')}</span>
                                                                    </td>
                                                                    <td
                                                                        className="d-none d-md-table-cell text-center align-middle"
                                                                        style={{ padding: "0.5rem" }}
                                                                    >
                                                                        {categorie.est_active ? (
                                                                            <span className="badge bg-success">Active</span>
                                                                        ) : (
                                                                            <span className="badge bg-danger">Inactive</span>
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        className="d-none d-md-table-cell text-center align-middle"
                                                                        style={{ padding: "0.5rem" }}
                                                                    >
                                                                        <button
                                                                            onClick={(e) => handleClick(e, categorie)}
                                                                            style={{
                                                                                borderRadius: "4px",
                                                                                width: "25px",
                                                                                height: "25px",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                cursor: "pointer",
                                                                                transition: "all 0.2s",
                                                                                margin: "0 auto"
                                                                            }}
                                                                            className={`btn btn-sm btn-action action-button ${menu?.categorie?.id === categorie.id ? "active" : ""}`}
                                                                            aria-label="Actions"
                                                                        >
                                                                            <FaEllipsisV className="icon" />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center">
                                                                Aucune catégorie trouvée
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>

                                            {/* Menu contextuel */}
                                            {menu && createPortal(
                                                <div
                                                    ref={menuRef}
                                                    className="context-menu"
                                                    style={{
                                                        position: "fixed",
                                                        top: `${menu.y}px`,
                                                        left: `${menu.x - 120}px`,
                                                        backgroundColor: "white",
                                                        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                                                        borderRadius: "4px",
                                                        zIndex: 1000,
                                                        minWidth: "150px",
                                                        border: "1px solid #ddd",
                                                        padding: "5px 0",
                                                    }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                                        <li className="context-menu-item"
                                                            style={{
                                                                padding: "8px 16px",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                            }}
                                                            onClick={() => {
                                                                handleOpenEditModal(menu.categorie);
                                                                closeMenu();
                                                            }}
                                                        >
                                                            <FaEdit style={{ color: "#117cf5", marginRight: "8px" }} />
                                                            Modifier
                                                        </li>
                                                        <li className="context-menu-item"
                                                            style={{
                                                                padding: "8px 16px",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                            }}
                                                            onClick={() => {
                                                                handleShowDeleteModal(menu.categorie);
                                                                closeMenu();
                                                            }}
                                                        >
                                                            <FaTrash style={{ color: "#dc3545", marginRight: "8px" }} />
                                                            Supprimer
                                                        </li>
                                                    </ul>
                                                </div>,
                                                document.body
                                            )}
                                        </div>

                                        {/* Pagination Controls */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div
                                                className="dataTables_info"
                                                role="status"
                                                aria-live="polite"
                                            >
                                                {totalItems === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Élément ${currentPage === 1
                                                        ? 1
                                                        : (currentPage - 1) * itemsPerPage + 1
                                                    } à ${currentPage * itemsPerPage > totalItems
                                                        ? totalItems
                                                        : currentPage * itemsPerPage
                                                    } sur ${totalItems}`}
                                            </div>

                                            <div>
                                                {Array.from({ length: totalPages }, (_, index) => (
                                                    <button
                                                        key={index + 1}
                                                        onClick={() => setCurrentPage(index + 1)}
                                                        className={`btn ${currentPage === index + 1
                                                            ? "btn-default"
                                                            : "btn-light"
                                                            } mx-1`}
                                                    >
                                                        {index + 1}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>

            {/* Modal d'ajout de catégorie avec QuillEditor */}
            <ModalAvecEditeur
                show={showModal}
                handleClose={handleCloseModal}
                title="Ajouter une catégorie"
                formData={nouvelleCategorie}
                handleSubmit={handleAjouterCategorie}
                submitText="Ajouter"
                imageFiles={imageFiles}
                imageDefautIndex={imageDefautIndex}
                handleImagesChange={handleImagesChange}
                handleSetImageDefaut={handleSetImageDefaut}
                handleRemoveImage={handleRemoveImage}
                isDefaultFromNew={isDefaultFromNew}
                nouvelleImageDefautId={nouvelleImageDefautId}
            />

            {/* Modal de modification de catégorie avec QuillEditor */}
            <ModalAvecEditeur
                show={showEditModal}
                handleClose={handleCloseEditModal}
                title="Modifier la catégorie"
                formData={nouvelleCategorie}
                handleSubmit={handleModifierCategorie}
                submitText="Modifier"
                isEdit={true}
                imageFiles={imageFiles}
                imageDefautIndex={imageDefautIndex}
                handleImagesChange={handleImagesChange}
                handleSetImageDefaut={handleSetImageDefaut}
                handleRemoveImage={handleRemoveImage}
                existingImages={categorieSelectionnee?.images || []}
                imagesASupprimer={imagesASupprimer}
                isDefaultFromNew={isDefaultFromNew}
                nouvelleImageDefautId={nouvelleImageDefautId}
                handleDefinirImageDefaut={handleDefinirImageDefaut}
                handleSupprimerImage={handleSupprimerImage}
            />

            {/* Modal de visualisation d'image */}
            <Modal show={showImageModal} onHide={handleCloseImageModal} size="lg">
                <Modal.Header closeButton className="pb-2">
                    <Modal.Title className="h5">Image de la catégorie</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center pt-3">
                    {selectedImage && (
                        <img
                            src={selectedImage}
                            alt="Catégorie"
                            style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain', borderRadius: '8px' }}
                        />
                    )}
                </Modal.Body>
            </Modal>

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton className="pb-2">
                    <Modal.Title className="h5">Confirmer la suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-3">
                    Êtes-vous sûr de vouloir supprimer la catégorie <strong>{categorieSelectionnee?.nom}</strong> ?
                    <br />
                    <small className="text-muted">
                        Cette action désactivera la catégorie. Elle ne sera plus visible dans l'application mobile.
                    </small>
                </Modal.Body>
                <Modal.Footer className="pt-2">
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        Annuler
                    </Button>
                    <Button variant="danger" onClick={handleDeleteCategorie}>
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CategoriesEvenement;